var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAutomaticPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 53,
    r: 16,
    fill: "#73DADC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 31L47 31",
    stroke: "#183657",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39L36.5 39",
    stroke: "#183657",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46L32 46",
    stroke: "#183657",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 18H53C53.5523 18 54 18.4477 54 19V31",
    stroke: "#183657",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 18H12C11.4477 18 11 18.4477 11 19V68C11 68.5523 11.4477 69 12 69H36.5",
    stroke: "#183657",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47 13H55.5C57.7091 13 59.5 14.7909 59.5 17V31",
    stroke: "#183657",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13H10C7.79086 13 6 14.7909 6 17V70.5C6 72.7091 7.79086 74.5 10 74.5H41.1193",
    stroke: "#183657",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20V13C18.5 12.4477 18.9477 12 19.5 12H24.2222C24.6518 12 25 11.6518 25 11.2222C25 7.78578 27.7858 5 31.2222 5H32.7778C36.2142 5 39 7.78578 39 11.2222C39 11.6518 39.3482 12 39.7778 12H45C45.5523 12 46 12.4477 46 13V20C46 20.5523 45.5523 21 45 21H19.5C18.9477 21 18.5 20.5523 18.5 20Z",
    stroke: "#183657",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 67.5039C48.3672 69.5757 52.7533 71.0884 56.2897 71.1729C59.8261 71.2574 63.305 70.2683 66.2679 68.3358C69.2308 66.4034 71.5385 63.6184 72.8868 60.348C74.235 57.0776 74.7436 52.4326 74.0035 48.9735L71.5032 49.4724C72.1313 52.4083 71.584 56.5634 70.4396 59.3391C69.2953 62.1148 67.3367 64.4786 64.8219 66.1188C62.3072 67.7589 59.3544 68.5985 56.3529 68.5268C53.3514 68.455 49.4362 66.7338 47.0026 64.9754L45.5 67.5039Z",
    fill: "#163652"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69 53.0039L71.9336 48.8131C72.2475 48.3646 72.8638 48.2519 73.3161 48.5604L78 51.7539",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9997 72.5009L45.9387 67.1157C45.7032 66.5005 46.1166 65.8297 46.772 65.7634L52.5417 65.1797",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 59.5C39.7585 56.0019 38.9885 49.9894 40.379 46.695C41.7695 43.4006 44.1358 40.6112 47.1595 38.7023C50.1831 36.7934 53.7189 35.8565 57.2911 36.0178C60.8633 36.1791 65.6624 38.8263 68.5017 41L67.0017 42.5C64.5919 40.6551 60.2036 38.799 57.1717 38.6621C54.1399 38.5252 51.1388 39.3203 48.5725 40.9405C46.0062 42.5607 43.9978 44.9282 42.8176 47.7243C41.6375 50.5204 42.3707 56.531 43 59.5H40.5Z",
    fill: "#163652"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9999 56.9882L41.8184 60.1709C42.3315 60.5098 43.026 60.3097 43.2802 59.7497L45.733 54.3455",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9995 42.9516L67.7694 42.7169C68.3838 42.6919 68.8303 42.1236 68.7092 41.5207L67.54 35.7023",
    stroke: "#163652",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 11.5,
    r: 2.5,
    fill: "#183657"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAutomaticPatient);
export default __webpack_public_path__ + "static/media/icon-automatic-patient.a07c70a61abeb104b8aa44901d55b8c4.svg";
export { ForwardRef as ReactComponent };